import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import SpaceReservationTab from '@/pages/admin/space/AdminSpaceReservationTab'
import SpaceListTab from '@/pages/admin/space/AdminSpaceListTab'
import SpaceSettingsTab from '@/pages/admin/space/AdminSpaceSettingsTab'

type TabKey = 'reservations' | 'spaces' | 'settings'

const TABS: { key: TabKey; label: string }[] = [
  { key: 'reservations', label: '예약내역관리' },
  { key: 'spaces', label: '공간관리' },
  { key: 'settings', label: '예약설정' },
]

export default function AdminSpaceManagement() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab') as TabKey | null
  const [activeTab, setActiveTab] = useState<TabKey>(tabParam ?? 'reservations')

  const handleTabChange = (tab: TabKey) => {
    setActiveTab(tab)
    setSearchParams({ tab })
  }

  return (
    <div className="bg-[#f5f2f0] min-h-screen p-8">
      <div className="max-w-[1200px] mx-auto">

        {/* Header */}
        <div className="mb-6">
          <h1 className="text-[22px] font-extrabold text-[#2a1f1a] mb-1">마루공간관리</h1>
          <p className="text-[13px] text-gray-400">
            {new Date().toLocaleDateString('ko-KR', {
              year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',
            })}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-5 bg-white rounded-xl border border-[#e8e0dc] p-1 w-fit shadow-[0_2px_8px_rgba(136,114,103,0.06)]">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              className={`px-5 py-2 rounded-lg text-[13px] font-semibold transition-all cursor-pointer border-none ${
                activeTab === tab.key
                  ? 'bg-[#887267] text-white shadow-sm'
                  : 'bg-transparent text-[#5a3d32] hover:bg-[#f5f2f0]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {activeTab === 'reservations' && <SpaceReservationTab />}
        {activeTab === 'spaces' && <SpaceListTab />}
        {activeTab === 'settings' && <SpaceSettingsTab />}

      </div>
    </div>
  )
}